module.exports = __webpack_public_path__ + "static/boat4-8dbd6d36db4b249e3d486daef4c2b727.jpg";